// extracted by mini-css-extract-plugin
export var articleHeader = "style-module--articleHeader--58cc0";
export var articleHeaderMini = "style-module--articleHeaderMini--fb87c";
export var articleImage = "style-module--articleImage--796dc";
export var articleTitle = "style-module--articleTitle--c0eda";
export var bar = "style-module--bar--6df3f";
export var category = "style-module--category--36dcc";
export var data = "style-module--data--b9f58";
export var date = "style-module--date--f1f8d";
export var limit = "style-module--limit--f7ced";
export var miniImage = "style-module--miniImage--51f8b";
export var saveContainer = "style-module--saveContainer--3d672";
export var slash = "style-module--slash--8010a";
export var sns = "style-module--sns--bc2af";
export var tag = "style-module--tag--e33ab";
export var tags = "style-module--tags--a50a1";